import { url } from "../Components/url";
import { fetchWithAuth } from "../Components/FetchWithAuth";

/**
 * @returns {Promise<{ success: boolean, apps: Array }>}
 */
export async function fetchNavApps({ includeMenus = true, refresh = false } = {}) {
  const q = new URLSearchParams();
  if (includeMenus) q.set("include_menus", "1");
  if (refresh) q.set("refresh", "1");
  const res = await fetchWithAuth(`${url}/apps?${q.toString()}`, {
    method: "GET",
    credentials: "include",
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(err || `GET /apps failed (${res.status})`);
  }
  return res.json();
}

export async function createNavApp(payload) {
  const res = await fetchWithAuth(`${url}/apps`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function updateNavApp(appId, payload) {
  const res = await fetchWithAuth(`${url}/apps/${encodeURIComponent(appId)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteNavApp(appId) {
  const res = await fetchWithAuth(`${url}/apps/${encodeURIComponent(appId)}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function createMenuItem(appId, payload) {
  const res = await fetchWithAuth(`${url}/apps/${encodeURIComponent(appId)}/menu`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function updateMenuItem(itemId, payload) {
  const res = await fetchWithAuth(`${url}/menu/${encodeURIComponent(itemId)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteMenuItem(itemId) {
  const res = await fetchWithAuth(`${url}/menu/${encodeURIComponent(itemId)}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function reorderMenuItems(appId, orderedIds) {
  const res = await fetchWithAuth(`${url}/apps/${encodeURIComponent(appId)}/menu/reorder`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ ordered_ids: orderedIds }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchMyDefaultApp() {
  const res = await fetchWithAuth(`${url}/app-defaults/me`, {
    method: "GET",
    credentials: "include",
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function setMyDefaultApp(appId) {
  const res = await fetchWithAuth(`${url}/app-defaults/me`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ app_id: appId || null }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchAdminDefaultApps() {
  const res = await fetchWithAuth(`${url}/app-defaults/admin`, {
    method: "GET",
    credentials: "include",
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function setRoleDefaultApp(roleName, appId) {
  const res = await fetchWithAuth(`${url}/app-defaults/role`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ role_name: roleName, app_id: appId || null }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function setUserDefaultApp(userId, appId) {
  const res = await fetchWithAuth(`${url}/app-defaults/user`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ user_id: userId, app_id: appId || null }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
